<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      width="1200px"
      :visible="visible"
      :title="$l('dialog_choose_report_person') || '选择巡检人员'"
      :before-close="close"
      :modal="true"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <Main ref="main" :data="data" />

      <span slot="footer" class="flex justify-end mt-20px mb-10px">
        <el-button @click="close" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>

        <el-button type="primary" class="ml-2" @click="confirm" size="small">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'

export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    data: { type: Array, default: () => [] },
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    confirm() {
      const data = this.$refs.main.getData()

      this.$emit('confirm', data)

      this.close()
    },
  },
}
</script>

<style lang="scss" scoped></style>
